// Components
import Box from '@components/helpers/box/Box'
import Flex from '@components/helpers/flex/Flex'

// Icons
import { IoSearchOutline } from 'react-icons/io5'

// Styles
import styles from './SearchButton.module.sass'

const SearchButton = () => (
  <Box
    backgroundColor="pink"
    borderRadius={{ sm: [50] }}
    className={styles.icon}
  >
    <Flex alignItems="center" justifyContent="center" fullHeight>
      <IoSearchOutline size={10} color="#FFF" />
    </Flex>
  </Box>
)

export default SearchButton
